export default "__VITE_ASSET__CAkZC5zV__"